import {DialogContent, DialogTitle, Typography} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../../misc/SmoothActionBar";
import {useContext, useState} from "react";
import {api} from "../../../../../api/API";
import {LogiCtrlRuleAction} from "../../../../../api/LogiCtrl";
import {EditContext} from "../../../../../misc/scroller/EditProvider";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {useProjectId} from "../../ProjectName";
import {useBackgroundAction} from "../../../manage/sov/UseBackgroundTask";
import {LogiCtrlButtons} from "./Buttons";

export function BulkOpeningEditor(props: {
    ids: number[];
    onCancel: () => void;
    onDone: () => void;
}) {
    const project = useProjectId();
    const edit = useContext(EditContext);
    const reloadRef = useSyncedRef(edit.reload);

    const [doorAction, setDoorAction] = useState<LogiCtrlRuleAction>(null);
    const [frameAction, setFrameAction] = useState<LogiCtrlRuleAction>(null);
    const [hwAction, setHwAction] = useState<LogiCtrlRuleAction>(null);

    const submit = useBackgroundAction({
        callback: async (input: {
            project: number;
            openings: number[];
            doorAction: LogiCtrlRuleAction;
            frameAction: LogiCtrlRuleAction;
            hwAction: LogiCtrlRuleAction;
        }) => {
            return api.logiCtrl.bulkUpsertRules(input);
        },
        onDone: () => {
            reloadRef.current();
            props.onDone();
        },
    });

    const noChanges = doorAction === null && frameAction === null && hwAction === null;

    const onSubmit = () => {
        if(noChanges) return;
        submit.callback({
            project: project,
            openings: props.ids,
            doorAction,
            frameAction,
            hwAction,
        });
    };

    return (
        <Dialog2 open onClose={() => props.onCancel()} maxWidth="xs" fullWidth onEnterPress={onSubmit}>
            <DialogTitle>Bulk Change Logistics</DialogTitle>
            <DialogContent>
                <div style={{display: "flex", flexDirection: "column", gap: 12, paddingTop: 8}}>
                    <Row label="Doors">
                        <LogiCtrlButtons value={doorAction} onChange={setDoorAction} />
                    </Row>
                    <Row label="Frames">
                        <LogiCtrlButtons value={frameAction} onChange={setFrameAction} />
                    </Row>
                    <Row label="Hardware">
                        <LogiCtrlButtons value={hwAction} onChange={setHwAction} />
                    </Row>
                </div>
            </DialogContent>
            <SmoothActionBar
                loading={submit.loading}
                error={submit.error}
                onCancel={() => props.onCancel()}
                onSubmit={onSubmit}
                actionName="Update"
                submitDisabled={noChanges}
            />
        </Dialog2>
    );
}

function Row(props: {label: string; children: React.ReactNode}) {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
        }}>
            <Typography variant="body2">{props.label}</Typography>
            {props.children}
        </div>
    );
}
